import { parseDate } from './parseDate';
export function toUTCTimestamp(inputDate) {
    var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    var millisecondsWithTzo = new Date(inputDate).getTime() + timezoneOffset;
    var dateDataConvertedToUTC = parseDate(new Date(millisecondsWithTzo).toUTCString());
    return dateDataConvertedToUTC;
}
